export enum PendingType {
    LOAD_BILLING_ACCOUNTS = 'LOAD_BILLING_ACCOUNTS',
    LOAD_CUSTOMER_INFORMATION = 'LOAD_CUSTOMER_INFORMATION',
    LOAD_INFLIGHT_ORDERS = 'LOAD_INFLIGHT_ORDERS',
    INITIALIZE_SCHEDULE_APPOINTMENT = 'INITIALIZE_SCHEDULE_APPOINTMENT',
    FETCH_AVAILABLE_TIME = 'FETCH_AVAILABLE_TIME',
    SUBMIT_SCHEDULE_APPOINTMENT = 'SUBMIT_SCHEDULE_APPOINTMENT',
    UPDATE_ACTIVATION_DATE = 'UPDATE_ACTIVATION_DATE',
}
